import { Stack, Typography } from '@mui/material';

import { ConfirmButtons } from '../shared/ConfirmButtons/ConfirmButtons';

export type OAuthConnectSuccessModalContentProps = {
  serviceName: string;
  onClose(): void;
};

export function OAuthConnectSuccessModalContent({
  serviceName,
  onClose,
}: OAuthConnectSuccessModalContentProps) {
  return (
    <Stack
      gap="24px"
      className="relative w-[500px] rounded-[10px] bg-neutral-950 p-24"
    >
      <Typography variant="h4" className="!text-white">
        {serviceName} Connect
      </Typography>

      <Typography variant="body2Medium" className="text-stone-200/80">
        You successfuly connected your {serviceName} account to UrbanMix
      </Typography>

      <ConfirmButtons
        confirm={{
          label: 'Close',
          onClick: onClose,
        }}
        cancel={{
          label: 'Cancel',
          onClick: onClose,
          hidden: true,
        }}
      />
    </Stack>
  );
}
